import React from "react";

const WBBonds = () => {
  return <div>WBBonds WBBonds</div>;
};

export default WBBonds;
